import React from 'react';

const AutoplannerHeader = ({ selectedTask, onCancel }) => (
  <div className="bg-white shadow">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="relative flex h-16 items-center justify-center">
        <h1 className="w-full text-center text-xl font-semibold text-gray-900">
          {selectedTask ? 'Edit' : 'Create'} Autoplanner Task
        </h1>
        <button
          type="button"
          className="absolute right-0 top-1/2 -translate-y-1/2 rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
          aria-label="Close"
          onClick={onCancel}
        >
          <svg className="h-6 w-6" viewBox="0 0 20 20" fill="none" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 6l8 8M6 14L14 6"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
);

export default AutoplannerHeader;
